import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/common/meta_logo_v2.png'
import _imports_1 from '@/assets/common/lst_logo_w.png'


const _hoisted_1 = { id: "login_layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "login_title_box" }, [
  /*#__PURE__*/_createElementVNode("p", null, "통합관제시스템"),
  /*#__PURE__*/_createElementVNode("p", null, "Management system using smart band")
], -1)
const _hoisted_4 = { class: "login_box" }
const _hoisted_5 = {
  action: "",
  method: "post",
  class: "login_form"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_7 = { class: "login_info" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "bottom_logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.userName) = $event)),
              placeholder: "ID"
            }, null, 512), [
              [_vModelText, $setup.state.userName]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              name: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.password) = $event)),
              placeholder: "Password"
            }, null, 512), [
              [_vModelText, $setup.state.password]
            ]),
            _createElementVNode("button", {
              type: "submit",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)))
            }, "로그인")
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.router.push('/join')))
            }, "회원가입"),
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.vasSurvey()))
            }, "설문VAS")
          ])
        ])
      ]),
      _hoisted_8
    ]),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      content: $setup.state.modalContent,
      onClose: $setup.modalClose
    }, null, 8, ["show", "content", "onClose"])
  ], 64))
}